"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.leafToHtml = void 0;
var _plateCommon = require("@udecode/plate-common");
var _htmlEntities = require("html-entities");
var _createElementWithSlate = require("./utils/createElementWithSlate");
var _renderToStaticMarkupClient = require("./utils/renderToStaticMarkupClient");
var _stripClassNames = require("./utils/stripClassNames");
var leafToHtml = function leafToHtml(editor, _ref) {
  var plateProps = _ref.plateProps,
    preserveClassNames = _ref.preserveClassNames,
    props = _ref.props;
  var _props = props,
    children = _props.children;
  return editor.plugins.reduce(function (result, plugin) {
    var _plugin$serializeHtml, _plugin$serializeHtml2, _renderToStaticMarkup;
    if (!plugin.isLeaf) return result;
    props = _objectSpread({}, (0, _plateCommon.pipeInjectProps)(editor, props), {
      children: result
    });
    var serialized = (_plugin$serializeHtml = (_plugin$serializeHtml2 = plugin.serializeHtml) === null || _plugin$serializeHtml2 === void 0 ? void 0 : _plugin$serializeHtml2.call(plugin, props)) !== null && _plugin$serializeHtml !== void 0 ? _plugin$serializeHtml : (0, _plateCommon.pluginRenderLeaf)(editor, plugin)(props);
    if (serialized === children) return result;
    var html = (0, _htmlEntities.decode)((_renderToStaticMarkup = (0, _renderToStaticMarkupClient.renderToStaticMarkup)((0, _createElementWithSlate.createElementWithSlate)(_objectSpread({}, plateProps, {
      children: serialized
    })))) !== null && _renderToStaticMarkup !== void 0 ? _renderToStaticMarkup : '');
    html = (0, _stripClassNames.stripClassNames)(html, {
      preserveClassNames: preserveClassNames
    });
    return html;
  }, children);
};
exports.leafToHtml = leafToHtml;